'use strict';

var React = require('react');

var SvgTimelineAttachmentMajor = function SvgTimelineAttachmentMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M17 4a1 1 0 0 1 1 1v13.5a1.5 1.5 0 0 1-1.5 1.5h-13a1.5 1.5 0 0 1-1.5-1.5v-17a1.5 1.5 0 0 1 1.5-1.5h4.5v2h-4v16h12v-13a1 1 0 0 1 1-1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 5v6c0 1.206.799 3 3 3s3-1.794 3-3v-8c0-1.206-.799-3-3-3h-1v2h1c.805 0 .988.55 1 1v7.988c-.012.462-.195 1.012-1 1.012-.805 0-.988-.55-1-1v-6a1 1 0 1 0-2 0z"
  }));
};

exports.SvgTimelineAttachmentMajor = SvgTimelineAttachmentMajor;
